import { useMemo } from 'react';

const useCreateReferralMessage = (message, data) => {
  return useMemo(() => {
    if (!message || !data.referralLink) return data.referralCode;
    const replaceMap = {
      referral_code: data.referralCode,
      referral_link: data.referralLink,
      appsflyer_link: data.referralLink
    };

    const keys = Object.keys(replaceMap);
    let referralText = message;

    keys.forEach((key) => {
      if (replaceMap[key]) {
        referralText = referralText.replace(`<${key}>`, replaceMap[key]);
      }
    });

    return referralText;
  }, [data.referralCode, data.referralLink, message]);
};

export default useCreateReferralMessage;
